import { render } from "./KnowledgeGraphEditor.vue?vue&type=template&id=17d28fcc&scoped=true"
import script from "./KnowledgeGraphEditor.vue?vue&type=script&lang=js"
export * from "./KnowledgeGraphEditor.vue?vue&type=script&lang=js"

import "./KnowledgeGraphEditor.vue?vue&type=style&index=0&id=17d28fcc&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d28fcc"]])

export default __exports__